import geojson from 'geojson';

import {LENS_MAX_CHECKOUT_ITEMS} from 'app/utils/constants';

export const MAX_CART_ITEMS = LENS_MAX_CHECKOUT_ITEMS;

export const CART_VERSION = 1;

export interface CartItemSnapshot {
  featureName: string;
  projectName: string;
  sourceDisplayName: string;
  thumbnailUrl: string | null;
  /**
   * The thumbnail is a multispectral scene's truecolor sibling, so it renders grayscaled the way
   * every other stand-in preview does. Absent on items stored before the flag existed.
   */
  thumbnailIsOverride?: boolean;
}

export interface CartItemV1 {
  id: string;
  addedAt: string;

  // Identity and quote — these fields are sent verbatim as a checkout item payload.
  projectId: string;
  featureCollectionId: number;
  featureId: number;
  sourceId: string;
  sensingTime: string;
  centsPerAcre: number;
  billableAcres: number;
  /**
   * Partial-AOI sub-area. Absent means the whole feature geometry. A MultiPolygon when the user
   * drew more than one rectangle.
   */
  geometry?: geojson.Polygon | geojson.MultiPolygon;

  snapshot: CartItemSnapshot;
}

export interface CartV1 {
  version: typeof CART_VERSION;
  items: CartItemV1[];
}

/** Everything needed to identify a scene, shared by cart items and checkout rejections. */
export interface SceneKeyParts {
  featureId: number;
  sourceId: string;
  sensingTime: string;
}

// Both sides of a scene key come from the API's one timestamp format, so the raw strings compare
// directly.
export function sceneKey({featureId, sourceId, sensingTime}: SceneKeyParts): string {
  return `${featureId}:${sourceId}:${sensingTime}`;
}

export const emptyCart = (): CartV1 => ({version: CART_VERSION, items: []});

export const isPartialAoiItem = (item: CartItemV1): boolean => item.geometry != null;

/** The stored sub-area as a feature, or null for a whole-feature order. */
export const cartItemSubsetFeature = (
  item: Pick<CartItemV1, 'geometry'>
): geojson.Feature<geojson.Polygon | geojson.MultiPolygon> | null =>
  item.geometry ? {type: 'Feature', properties: {}, geometry: item.geometry} : null;
